import {
  Component,
  Input,
  ElementRef,
  ViewChild,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { DetectedObject } from '../types/bounding-box.model';

@Component({
  selector: 'nw-bounding-box-visualizer',
  templateUrl: './bounding-box-visualizer.component.html',
  styleUrls: ['./bounding-box-visualizer.component.css'],
})
export class BoundingBoxVisualizerComponent implements OnInit {
  @Input() imageUrl!: string;
  @Input() detectedObjects: DetectedObject[] = [];
  @Input() loading = false;
  @ViewChild('imageElement') imageElement!: ElementRef<HTMLImageElement>;
  @Output() change = new EventEmitter<DetectedObject[]>();
  changed = false;
  activeObject: DetectedObject | null = null;
  resizing = false;
  startX = 0;
  startY = 0;

  ngOnInit(): void {}

  onMouseDown(event: MouseEvent, obj: DetectedObject): void {
    this.activeObject = obj;
    this.startX = event.clientX;
    this.startY = event.clientY;
    this.resizing = false;
  }

  onResizeMouseDown(event: MouseEvent, obj: DetectedObject): void {
    event.stopPropagation();
    this.activeObject = obj;
    this.startX = event.clientX;
    this.startY = event.clientY;
    this.resizing = true;
  }

  onMouseMove(event: MouseEvent): void {
    if (!this.activeObject) return;

    const dx =
      (event.clientX - this.startX) / this.imageElement.nativeElement.width;
    const dy =
      (event.clientY - this.startY) / this.imageElement.nativeElement.height;

    this.changed = true;

    if (this.resizing) {
      this.activeObject.box.bottomX += dx;
      this.activeObject.box.bottomY += dy;
    } else {
      this.activeObject.box.topX += dx;
      this.activeObject.box.topY += dy;
      this.activeObject.box.bottomX += dx;
      this.activeObject.box.bottomY += dy;
    }

    this.startX = event.clientX;
    this.startY = event.clientY;
  }

  onMouseUp(): void {
    this.activeObject = null;
    this.resizing = false;
  }

  save() {
    this.change.emit([...this.detectedObjects]);
  }
}
